/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type Conversations_conversations$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Notifications_viewer$ref: FragmentReference;
export type Notifications_viewer = {|
  +regInfo: ?$ReadOnlyArray<?{|
    +countryCode: ?string
  |}>,
  +isBuyerActivityDropdownDisabled: ?boolean,
  +conversations?: ?{|
    +$fragmentRefs: Conversations_conversations$ref
  |},
  +$refType: Notifications_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Notifications_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 5
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": false
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "regInfo",
      "name": "regionalInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "RegionalInfo",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "countryCode",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": "isBuyerActivityDropdownDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "isBuyerActivityDropdownDisabled",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"isBuyerActivityDropdownDisabled\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNotifications",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "conversations",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first",
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "notifications",
              "value": true,
              "type": "Boolean"
            }
          ],
          "concreteType": "ConversationConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Conversations_conversations",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6d0b16a15d710bda630ea9c133abc561';
module.exports = node;
